import React, { useEffect } from 'react';
import TW_log from '../machineUI/NaviBar/icons/travel-wifi-logo.png';
import localRequest from '../services/LocalServer/localRequest';

export default function OutOfOrder(props) {
  useEffect(() => {
    localRequest({
      method: 'post',
      url: `${process.env.REACT_APP_LOCAL_API}/resetStatus`,
      data: {},
    }).then(() => {});
  }, []);

  // async function fetchAPI() {
  //   await axios
  //     .get(`${process.env.REACT_APP_LOCAL_API}/reinstateRequest`, {
  //       headers: {
  //         'X-CompanyID': 'magex',
  //         'X-Token': process.env.REACT_APP_X_TOKEN,
  //       },
  //     })
  //     .then((status) => {
  //       if (status.data.reason) {
  //         clearInterval(interval);
  //         history.push(linkToURL);
  //       }
  //     });
  // }

  // var interval = setInterval(() => fetchAPI(), 5000);

  return (
    <div className="payment-container">
      <div className="out-of-stock-div">
        <img className="payment-logo-img" src={TW_log}></img>
        <div className="out-of-stock">Sorry, this kiosk is temporarily unavailable.</div>
      </div>
    </div>
  );
}
